module.exports = __webpack_public_path__ + "media/images/covers/discover-your-future/discover-logo-6-ad2582e662905b1be865d554d6cfaefe.png";